import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "E:/workSpacke/screening-sys/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RightPanel from "@/components/RightPanel";
import { Navbar, Sidebar, AppMain, TagsView, Settings, Logo, Warning, Notice } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import Breadcrumb from "@/components/Breadcrumb";
import { mapState } from "vuex";
export default {
  name: "Layout",
  components: {
    RightPanel: RightPanel,
    Navbar: Navbar,
    Sidebar: Sidebar,
    AppMain: AppMain,
    TagsView: TagsView,
    Settings: Settings,
    Logo: Logo,
    Breadcrumb: Breadcrumb,
    Warning: Warning,
    Notice: Notice
  },
  data: function data() {
    return {
      workbenchscreen: true,
      teacherlimits: false
    };
  },
  mixins: [ResizeMixin],
  computed: _objectSpread(_objectSpread({}, mapState({
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    },
    device: function device(state) {
      return state.app.device;
    },
    breadcrumb: function breadcrumb(state) {
      return state.app.breadcrumb;
    },
    showSettings: function showSettings(state) {
      return state.settings.showSettings;
    },
    needTagsView: function needTagsView(state) {
      return state.settings.tagsView;
    },
    fixedHeader: function fixedHeader(state) {
      return state.settings.fixedHeader;
    },
    is_first: function is_first(state) {
      return state.user.is_first;
    },
    grade_code: function grade_code(state) {
      return state.user.grade_code;
    },
    clazz: function clazz(state) {
      return state.user.clazz;
    },
    roles: function roles(state) {
      return state.user.roles;
    }
  })), {}, {
    classObj: function classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    }
  }),
  created: function created() {
    this.teacherlimits = this.roles[0] === 'schoolclazz' && this.clazz == '0' && this.grade_code == '0';
    this.getpresentUrl();
  },
  methods: {
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", {
        withoutAnimation: false
      });
    },
    jumppas: function jumppas() {
      this.$store.commit("user/SET_IS_FIRST", false);
      this.$router.push({
        path: "/setting"
      });
    },
    handleClose: function handleClose() {
      this.$store.commit("user/SET_IS_FIRST", false);
    },
    // 监听路由变化 改变layout navbarbox样式
    getpresentUrl: function getpresentUrl() {
      var presentUrl = this.$route.path.split("/")[1];
      if (presentUrl == "workbenchscreen" || presentUrl == "workbench" || presentUrl == "workbenchcity" || presentUrl == "workbenchschool" || presentUrl == "workbenchnationwide") {
        // 工作台页面不显示
        this.workbenchscreen = false;
      } else {
        this.workbenchscreen = true;
      }
    }
  },
  watch: {
    $route: function $route(to, from) {
      //监听路由是否变化
      this.getpresentUrl();
    }
  }
};